<!--==================================================
    component name  : 多國語系切換按鈕
    author          : Samma
    last update     : 2020-05-04
    use description : 
==================================================-->
<template>
  <!--首頁-->
  <div v-if="type == 'index'" class="langbtn">
    <div
      class="button"
      v-for="lang_btn in lang_btns"
      v-bind:key="lang_btn.id"
      v-bind:class="{ active: lang_btn.is_active }"
      v-on:click="vSwitchLang(lang_btn.no)"
    >
      {{ lang_btn.text }}
    </div>
  </div>

  <!--內頁(一般模式)-->
  <div v-else-if="type == 'content'" class="languagebtn d-none d-xl-block">
    <div
      class="orangebox"
      @mousemove="vRefreshStyle()"
      @mousedown="vRefreshStyle()"
      @click="vRefreshStyle()"
    >
      <i class="fas fa-globe-americas"></i>
      <div
        class="latextbox"
        v-for="lang_btn in lang_btns"
        v-bind:key="lang_btn.id"
        v-on:click="vSwitchLang(lang_btn.no)"
      >
        <div class="latext" v-bind:class="{ active: lang_btn.is_active }">
          {{ lang_btn.text }}
        </div>
      </div>
    </div>
  </div>

  <!--內頁(mobile模式)-->
  <div v-else class="languagebtn2 d-xl-nonel" :class="{ show: mobile_open }">
    <div
      class="button"
      v-for="lang_btn in lang_btns"
      v-bind:key="lang_btn.id"
      v-bind:class="{ active: lang_btn.is_active }"
      v-on:click="vSwitchLang(lang_btn.no)"
    >
      {{ lang_btn.text }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'LangBtns',
  props: {
    type: String,
  },
  data: function () {
    return {
      mobile_open: false,
      //預設語系
      lang_default: 'zh-TW',
      //放在 sessionStorage，當前使用語系的 key
      ssk: 'use_lang',
      //多國語系按鈕
      lang_btns: [
        { id: 1, no: 'zh-TW', text: '中', is_active: false },
        { id: 2, no: 'en-US', text: 'EN', is_active: false },
      ],
    };
  },
  mounted: function () {
    var current_lang = sessionStorage.getItem(this.ssk);
    var language =
      current_lang ||
      (navigator.languages && navigator.languages[0]) ||
      navigator.language ||
      navigator.userLanguage;

    //非中文語系
    if (language.indexOf('zh') < 0) {
      this.lang_default = 'en-US';
    }

    this.vSwitchLang(this.lang_default);
  },
  methods: {
    //切換語系
    vSwitchLang: function (lang) {
      this.$parent.$i18n.locale = lang;
      //變換樣式
      var origin_lang_btns = [];
      var i = 0;
      for (i = 0; i < this.lang_btns.length; i++) {
        origin_lang_btns.push(this.lang_btns[i]);
      }
      for (i = this.lang_btns.length - 1; i >= 0; i--) {
        this.lang_btns.pop();
      }
      for (i = 0; i < origin_lang_btns.length; i++) {
        origin_lang_btns[i]['is_active'] = false;
        if (origin_lang_btns[i]['no'] == lang) {
          origin_lang_btns[i]['is_active'] = true;
        }
        this.lang_btns.push(origin_lang_btns[i]);
      }
      //當前使用語系進行儲存
      sessionStorage.setItem(this.ssk, lang);
    },
    //顯示切換語系選單
    vToggleLangMenu: function (mobile_open) {
      this.mobile_open = mobile_open;
      this.vRefreshStyle();
    },
    //依當前語系更新多國語系切換鈕樣式
    vRefreshStyle: function () {
      var current_lang = sessionStorage.getItem(this.ssk);
      this.vSwitchLang(current_lang);
    },
  },
};
</script>
